import {ngAsync} from 'shared/utils/ng-@decorators';
import {transferify} from 'shared/utils/data-service-utils';
import type {UserPreference} from 'typings/portaro.be.types';
import type {AjaxService} from 'core/data-services/ajax.service';
import type {UserId} from 'src/features/user/types';

export default class UserPreferencesDataService {
    public static readonly serviceName = 'userPreferencesDataService';

    public static readonly USERS_PREFERENCES_ROUTE = 'user-preferences';

    /*@ngInject*/
    constructor(private ajaxService: AjaxService) {
    }

    @ngAsync()
    public async query(userId: UserId, preferenceKeys = [] as number[]): Promise<UserPreference[]> {
        return this.ajaxService
            .createRequest(UserPreferencesDataService.USERS_PREFERENCES_ROUTE)
            .get({user: userId, preferenceKeys});
    }

    @ngAsync()
    public async save(preference: UserPreference): Promise<any> {
        return this.ajaxService
            .createRequest(UserPreferencesDataService.USERS_PREFERENCES_ROUTE)
            .post(transferify(transferify({key: preference.keyId, user: preference.user.id, value: preference.editedValue})));
    }
}
